export default "__VITE_ASSET__Sh90cf7i__"